import { formatPriceInCents } from '@/lib/utils/format-currency'
import type { Product } from '@/schemas/product.schema'

export type ProductCardSize = 'hero' | 'regular'

export interface ProductCardModelProps {
  product: Product
  size: ProductCardSize
}

export function useProductCardModel({ product, size }: ProductCardModelProps) {
  return {
    product,
    size,
    slug: product.slug,
    formattedPrice: formatPriceInCents(product.priceInCents),
  }
}
